import Vue from 'vue'

const CardInstance = Vue.extend(require('./download.vue').default);
let instance = null

let getInstance = () => {
  return new CardInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
}

let Download = (subject_type, query, id1, id, el, type) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  el.appendChild(instance.$el);
  instance.open(subject_type, query, id1, id, type)
}


export default Download
